/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ListProjectsStatusNot = typeof ListProjectsStatusNot[keyof typeof ListProjectsStatusNot] | null;


export const ListProjectsStatusNot = {
  active: 'active',
  archived: 'archived',
} as const;
